export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/09afdd8b7907-tooliconwhatsapp.jpg',
  },
  title: 'Can you tell us more about the different ways the scammer contacted you?',
}
